import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField, Button, Divider, Drawer, InputLabel  } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import SvgIcon from '@material-ui/core/SvgIcon';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import { useSpring, animated } from 'react-spring/web.cjs';// web.cjs is required for IE 11 support

import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    },    
  paper: {
    border: '1px solid',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  drawerPaper: {
    overflow:"hidden",
    position: "relative",
    whiteSpace: "nowrap",
    height: 800,
    width: 440,
    backgroundColor: "#292833",
    color: "#f2f3f8",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflow: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(0),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },  
  tree: {
    height: 264,
    flexGrow: 1,
    maxWidth: 400,
  },  
}));

function MinusSquare(props) {
    return (
      <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
      </SvgIcon>
    );
  }
  
  function PlusSquare(props) {
    return (
      <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
      </SvgIcon>
    );
  }
  
  function CloseSquare(props) {
    return (
      <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
      </SvgIcon>
    );
  }
  
  function TransitionComponent(props) {
    const style = useSpring({
      from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
      to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
    });
  
    return (
      <animated.div style={style}>
        <Collapse {...props} />
      </animated.div>
    );
  }
  
  TransitionComponent.propTypes = {
    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes.bool,
  };

const StyledTreeItem = withStyles((theme) => ({
    iconContainer: {
      '& .close': {
        opacity: 0.3,
      },
    },
    group: {
      marginLeft: 7,
      paddingLeft: 18,
      borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
    },
  }))((props) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);
  

export default function SelectedDrawer(props) {

  //const { open, children, onEnter, onExited, ...other } = props;
  const { selectedDispatchNo, toggleDrawer } = props;    

  const classes = useStyles();
  const {t} = useTranslation('batchManagement');

  const [isShowShortCut, setIsShowShortCut] = useState(true);
  const [value, setValue] = React.useState('1');
  //const [selectedDispatchNo,setSelectedDisPatchNo] = useState([]);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
        <Drawer  open={isShowShortCut} 
            anchor={'bottom'}
            classes={{
                paper: clsx(classes.drawerPaper, !isShowShortCut && classes.drawerPaperClose),
              }}
              style={{ position: 'fixed', bottom: 20, right: 0, top: 300, left: 'unset' }}
            onClose={e=>toggleDrawer(false,e)}>
            <div className={classes.root}
                role="presentation"
                // onClick={e=>toggleDrawer(false,e)}
                // onKeyDown={e=>toggleDrawer(false,e)}
            >
                <TabContext value={value}>
                    <AppBar position="static">
                    <TabList onChange={handleTabChange} aria-label="simple tabs example">
                        <Tab label={t('dispatch_no')} value="1" />
                        <Tab label={t('master_air_waybill')} value="2" />
                    </TabList>
                    </AppBar>
                    <TabPanel value="1">
                        <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                            <span style={{width: 200, marginRight: 30}}>
                                <InputLabel variant="filled">{t('label_select_batch_no')}</InputLabel>   
                            </span>  
                            <span style={{width: 100, marginRight: 30}}>
                                <InputLabel variant="filled">{t('label_select_state')}</InputLabel>   
                            </span>  
                            <span style={{width: 100, marginRight: 30}}>
                                <InputLabel variant="filled">{t('label_select_count')}</InputLabel>   
                            </span>  
                        </div>
                        <Divider/>  
                        {
                            <div style={{height : 500, overflow: 'auto'}}>
                            <TreeView
                                className={classes.tree}
                                defaultExpanded={['1']}
                                defaultCollapseIcon={<MinusSquare />}
                                defaultExpandIcon={<PlusSquare />}
                                defaultEndIcon={<CloseSquare />}
                                >
                                {
                                    selectedDispatchNo.filter((row)=>row.selected === true).map((item,index)=>{
                                        const state = getSameState(item);
                                        const sum = getTotalItems(item);                                        
                                        return (
                                          <StyledTreeItem nodeId={item.dispatch_no} label={item.dispatch_no + " --- " + state + "---" + sum}>
                                          {
                                            item.mawb.filter((ele)=>ele.selected).map((ele2,idx2)=>(
                                              (!ele2.tracking[ele2.tracking.length - 1] || !ele2.tracking[ele2.tracking.length - 1].transition)
                                              ?
                                                <StyledTreeItem 
                                                  nodeId={ele2.master_air_waybill} 
                                                  label={ele2.master_air_waybill +  "  --  " + " na "  + "  --  " +  ele2.total_items}
                                                />
                                              :
                                              <StyledTreeItem 
                                                nodeId={ele2.master_air_waybill} 
                                                label={ele2.master_air_waybill +  "  --  " + ele2.tracking[ele2.tracking.length - 1].transition  + "  --  " +  ele2.total_items}
                                              />
                                            )) 
                                            }
                                          </StyledTreeItem>        
                                        )
                                    })
                                }
                            </TreeView>                        
                            </div>    
                        }
                    </TabPanel>
                    <TabPanel value="2">
                        <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 30}} >
                            <span style={{width: 160}}>
                                <InputLabel variant="filled">{t('label_select_mawb')}</InputLabel>   
                            </span>  
                            <span style={{width: 100, marginRight: 30}}>
                                <InputLabel variant="filled">{t('label_select_state')}</InputLabel>   
                            </span>                              
                            <span style={{width: 80}}>
                                <InputLabel variant="filled">{t('label_select_count')}</InputLabel>   
                            </span>  
                        </div>
                        <Divider/>  
                        <div style={{height : 500, overflow: 'auto'}}>
                        {
                            selectedDispatchNo.filter((row)=>row.selected === true).map((item,index)=>(
                              item.mawb.filter((ele)=>ele.selected).map((ele2,idx2)=>(
                                <div key={ele2.master_air_waybill}>
                                <TextField style={{width: 150}}
                                    id="mswb"
                                    defaultValue={ele2.master_air_waybill}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    variant="outlined"
                                />
                                <TextField style={{width: 160}}
                                    id="count"
                                    defaultValue={ 
                                      (!ele2.tracking[ele2.tracking.length - 1] || !ele2.tracking[ele2.tracking.length - 1].transition)
                                      ? " na " 
                                      :ele2.tracking[ele2.tracking.length - 1].transition
                                    }
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    variant="outlined"
                                />                                     
                                <TextField style={{width: 60}}
                                    id="count"
                                    defaultValue={ele2.total_items}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    variant="outlined"
                                />                                    
                                </div>
                              ))
                              ))
                        }
                        </div>
                            
                    </TabPanel>
                </TabContext>
            </div>
        </Drawer>      
    </div>
  );

  /**
   * if the last state is the same then return then last state otherwise return "********"
   * @param {*} item 
   * @returns 
   */
  function getSameState(dispatchNo) {
    let state = "********************";

    if (dispatchNo.sameState === true) {
      let lastTrackingIndex = dispatchNo.mawb[0].tracking.length - 1;
      state = dispatchNo.mawb[0].tracking[lastTrackingIndex].transition;
    } 

    return state;
  }

  /**
   * summary the total_items of the master_air_way_bill which belong to the selected dispatch_no
   * @param {*} item 
   * @returns 
   */                      
  function getTotalItems(item) {
    let nTotal = 0;
    for (let i = 0; i < item.mawb.length; i ++) {
      if (item.mawb[i].selected) 
        nTotal += item.mawb[i].total_items;
    }

    return nTotal;
  }


}

